module.exports = __webpack_public_path__ + "media/img/private-venue/trust-7fbb11919458ffde051787ea7118646e.svg";